import React from "react";
import axios from "axios";
import Card from "./Cards";
import { image } from "../helpers";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      movie: null,
      tv: null
    };
  }

  fetch = types => {
    types.map(type => {
      return axios.get(`discover/${type}`).then(response => {
        this.setState({ [type]: response.data });
      });
    });
  };

  componentDidMount() {
    this.fetch(["tv", "movie"]);
  }

  render() {
    return (
      <React.Fragment>
        <div className="mb-4">
          <h1 className="font-light mb-2">Movies</h1>

          <div className="flex flex-wrap -mx-2">
            {this.state.movie &&
              this.state.movie.results.length > 0 &&
              this.state.movie.results.slice(0, 4).map(movie => {
                return (
                  <Card
                    className="w-full lg:w-1/2 px-2 mb-3 text-center"
                    link={`movie/${movie.id}`}
                    image={image({
                      image: movie,
                      w: 128,
                      h: 128
                    })}
                    description={movie.overview}
                    title={movie.title}
                    key={movie.id}
                  />
                );
              })}
          </div>
        </div>

        <div className="mb-4">
          <h1 className="font-light mb-2">Tv Shows</h1>

          <div className="flex flex-wrap -mx-2">
            {this.state.tv &&
              this.state.tv.results.length > 0 &&
              this.state.tv.results.slice(0, 4).map(tv => {
                return (
                  <Card
                    className="w-full lg:w-1/2 px-2 mb-3 text-center"
                    link={`tv/${tv.id}`}
                    image={image({
                      image: tv,
                      w: 128,
                      h: 128
                    })}
                    description={tv.overview}
                    title={tv.name}
                    key={tv.id}
                  />
                );
              })}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js